<template>
  <d-form @submit.prevent="save" :validated="hasErrors">
    <d-form-row>
      <!-- Nome -->
      <d-col lg="7" md="12" class="form-group">
        <label for="name">Nome</label>
        <d-form-input
          :state="hasErrorFiled('name')"
          type="text"
          id="name"
          placeholder="Nome"
          v-model="model.name"
          :readonly="isRepresentative"
        />
        <d-form-invalid-feedback>Nome é obrigatório</d-form-invalid-feedback>
      </d-col>

      <!-- Email -->
      <d-col lg="5" md="6" class="form-group">
        <label for="feContactEmail">E-mail</label>
        <d-form-input
          type="email"
          v-model="model.email"
          id="feContactEmail"
          placeholder="E-mail"
          :readonly="isRepresentative"
        />
      </d-col>
    </d-form-row>

    <d-form-row>
      <!-- Id BMB -->
      <d-col md="3" class="form-group">
        <label for="feIdBmb">Id Bmb</label>
         <d-form-input
          type="text"
          id="feIdBmb"
          placeholder="Id Bmb"
          v-model="model.id_bmb"
          :readonly="isRepresentative"
        />
      </d-col>

      <!-- Telefone -->
      <d-col md="3" class="form-group">
        <label for="feTelefone">Telefone</label>
        <input-phone
          id="feTelefone"
          :model.sync="model.phone"
          :state="hasErrorFiled('phone')"
          :readonly="isRepresentative"
        ></input-phone>
        <d-form-invalid-feedback
          >Telefone é obrigatório</d-form-invalid-feedback
        >
      </d-col>

      <!-- Celular -->
      <d-col md="3" class="form-group">
        <label for="feCelular">Celular</label>
        <input-phone
          id="feCelular"
          :model.sync="model.cellphone"
          :readonly="isRepresentative"
        ></input-phone>
      </d-col>

      <!-- Site -->
      <d-col md="3" class="form-group">
        <label for="feSite">Site</label>
        <d-form-input
          type="text"
          id="feSite"
          placeholder="Site"
          v-model="model.site"
          :readonly="isRepresentative"
        />
      </d-col>

    </d-form-row>

    <d-form-row>
      <!-- Facebook -->
      <d-col md="4" class="form-group">
        <label for="feFacebook">Facebook</label>
        <d-form-input
          type="text"
          id="feFacebook"
          placeholder="Facebook"
          v-model="model.social_medias.facebook"
          :readonly="isRepresentative"
        />
      </d-col>

      <!-- Instagram -->
      <d-col md="4" class="form-group">
        <label for="feInstagram">Instagram</label>
        <d-form-input
          type="text"
          id="feInstagram"
          placeholder="Instagram"
          v-model="model.social_medias.instagram"
          :readonly="isRepresentative"
        />
      </d-col>

      <!-- Premium -->
      <d-col md="4" class="form-group" v-if="showColors">
        <label for="fePremium">Colors</label>
        <d-checkbox
          toggle
          :checked="model.premium == 1"
          @change="togglePremium"
          class="custom-toggle-sm"
        >
          <span v-if="model.premium == 1">Sim</span>
          <span v-else>Não</span>
        </d-checkbox>
      </d-col>
    </d-form-row>

    <d-form-row>
      <h6 class="col-12">Quantidade de expositores:</h6>
      <!-- Sample8 -->
      <d-col md="6" xl="3" class="form-group">
        <label for="feSample8">Para sample: <small>(8 lugares)</small></label>
        <d-form-input
          type="number"
          id="feSample8"
          placeholder="Ex.: 4"
          v-model="model.expositors.sample"
        />
      </d-col>

      <!-- Product -->
      <d-col md="6" xl="3" class="form-group">
        <label for="feProduct">Peças de Produto: <small>(5 andares)</small></label>
        <d-form-input
          type="number"
          id="feProduct"
          placeholder="Ex.: 3"
          v-model="model.expositors.product"
        />
      </d-col>

      <!-- Ekko -->
      <d-col md="6" xl="3" class="form-group">
        <label for="feEkko">Linha Ekko Plus: <small>(5 andares)</small></label>
        <d-form-input
          type="number"
          id="feEkko"
          placeholder="Ex.: 2"
          v-model="model.expositors.ekko"
        />
      </d-col>

      <!-- Base -->
      <d-col md="6" xl="3" class="form-group">
        <label for="feBase">Base para pisos:</label>
        <d-form-input
          type="number"
          id="feBase"
          placeholder="Ex.: 1"
          v-model="model.expositors.base"
        />
      </d-col>
    </d-form-row>

    <d-form-row>
      <h6 class="mb-2 col-12">Marque onde a loja possui o logotipo da Castelatto</h6>
      <!-- Facade -->
      <d-col cols="auto" class="flex-wrap d-flex align-items-center" >
        <input
          type="checkbox"
          id="feFacade"
          class="mr-2"
          v-model="model.logo_place.front"
        />
        <label for="feFacade" class="mb-0">Na fachada</label>
      </d-col>
      <!-- Showroom -->
      <d-col cols="auto" class="flex-wrap d-flex align-items-center" >
        <input
          type="checkbox"
          id="feShowroom"
          class="mr-2"
          v-model="model.logo_place.showroom"
        />
        <label for="feShowroom" class="mb-0">No showroom</label>
      </d-col>
      <d-col cols="12 form-group">
        <small><i class="pr-1 fa fa-info-circle"></i>Não se esqueça de anexar fotos do logotipo Castelatto no campo abaixo</small>
      </d-col>
    </d-form-row>

    <d-form-row>
      <d-tabs class="px-1 mb-4 w-100" ref="tabs">
        <d-tab title="Endereço" class="p-1 pt-3" v-if="!isRepresentative">
          <addresses
            :model.sync="model.address"
            @changeCep="setCoordenate"
            ref="address"
          />
          <d-form-row class="px-3">
            <!-- Latitude -->
            <d-col md="4" class="form-group">
              <label for="feLatitude">Latitude</label>
              <d-form-input
                type="number"
                step="0.0001"
                id="feLatitude"
                placeholder="Latitude"
                v-model="model.lat"
                :readonly="isRepresentative"
              />
            </d-col>
            <!-- Longitude -->
            <d-col md="4" class="form-group">
              <label for="feLongitude">Longitude</label>
              <d-form-input
                type="number"
                step="0.0001"
                id="feLongitude"
                placeholder="Longitude"
                v-model="model.lng"
                :readonly="isRepresentative"
              />
            </d-col>
          </d-form-row>
          <div class="px-3 mb-3" v-if="model.lat && model.lng">
            <google-map :lat="model.lat" :lng="model.lng"/>
          </div>
        </d-tab>
        <d-tab title="Indicações" class="p-1 pt-3" v-if="model.id && !isRepresentative">
          <indicators :id="model.id" ref="indicators" />
        </d-tab>
        <d-tab title="Usuários" class="p-1 pt-3" v-if="model.id && isAdmin">
          <users-form
            :model.sync="model.users"
            :resellerId="model.id"
            @updateUser="updateUser"
            ref="users"
          />
        </d-tab>
        <d-tab title="Representantes" class="p-1 pt-3" v-if="isAdmin || isCommercial">
          <representatives
            :model.sync="model.representatives"
            :resellerId="model.id"
            ref="representatives"
          />
        </d-tab>
        <d-tab title="Imagens" class="p-1 pt-3">
          <image-tabs />
        </d-tab>
      </d-tabs>
    </d-form-row>
  </d-form>
</template>

<script>
import config from '_config';
import { mapActions } from 'vuex';
import mixin from '_common/mixins/ValidateForm';
import Events from '_utils/events';
import InputPhone from '_shared/InputPhone.vue';
import GoogleMap from '_shared/GoogleMap.vue';
import ResellerService from '_services/rest/modules/reseller';
import { cloneDeep, capitalize } from '_utils';
import Indicators from './Indicators.vue';
import Addresses from './Addresses.vue';
import UsersForm from './UsersForm.vue';
import ImageTabs from './ImageTabs.vue';
import Representatives from './RepresentativesForm.vue';
import { MODEL, _LOAD_MODEL_, _SAVE_RESELLER_SUCCESS_ } from './ResellerModel';

export default {
  name: 'reseller-form',
  mixins: [mixin],
  components: {
    Addresses,
    ImageTabs,
    GoogleMap,
    UsersForm,
    Indicators,
    InputPhone,
    Representatives,
  },
  data() {
    return {
      model: cloneDeep(MODEL),
      loading: false,
      errors: {
        name: { required: false },
        phone: { required: false },
        contacts_name: { required: false },
      },
    };
  },
  computed: {
    isAdmin() {
      const { isAdmin } = this.$store.state.user;
      return isAdmin;
    },
    isCommercial() {
      const { user } = this.$store.state.user;
      if (user && user.settings.user_type_id === config.COMMERCIAL_TYPE_ID) {
        return true;
      }
      return false;
    },
    isRepresentative() {
      const { user } = this.$store.state.user;
      if (user && user.settings.type.slug === 'representative') {
        return true;
      }
      return false;
    },
    showColors() {
      if (this.isAdmin || this.isCommercial) {
        return true;
      }
      return false;
    },
  },
  methods: {
    ...mapActions([
      'activeAlert',
      'checkAdmin',
    ]),
    capitalizeInput(field) {
      this.model[field] = capitalize(this.model[field]);
    },
    setCoordenate(address) {
      ResellerService.getCoordenates(address)
        .then(response => {
          const { location } = response[0].geometry;
          this.model.lat = location.lat.toString();
          this.model.lng = location.lng.toString();
        });
    },
    checkRepresentative() {
      if (this.isCommercial && this.model.representatives.length === 0) {
        this.activeAlert({ message: 'Falta preencher um representante', theme: 'danger' });
        return false;
      }
      return true;
    },
    save() {
      if (this.checkForm() && this.checkRepresentative()) {
        this.toggleLoading();
        ResellerService.save(this.model)
          .then(response => {
            this.success(response);
          })
          .catch(error => {
            this.toggleLoading();
            this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' });
          });
      }
      return null;
    },
    success(resellerSaved) {
      this.toggleLoading();
      this.activeAlert({ message: 'Parceiro salvo com sucesso', theme: 'success' });
      Events.$emit(_SAVE_RESELLER_SUCCESS_, resellerSaved);
    },
    togglePremium() {
      this.model.premium = (this.model.premium === 1) ? 0 : 1;
    },
    toggleLoading() {
      this.loading = !this.loading;
      Events.$emit('loading', this.loading);
    },
    updateTabs() {
      setTimeout(() => {
        if (this.$refs.tabs) {
          this.$refs.tabs.updateTabs();
        }
      }, 10);
    },
    updateUser(users) {
      this.model.users = users;
    },
  },
  mounted() {
    this.checkAdmin();
    Events.$on(_LOAD_MODEL_, newValue => {
      this.model = { ...newValue };
      this.updateTabs();
    });
  },
};
</script>

<style lang="scss" scoped>
.tab-pane {
  border: 1px solid #e1e5eb;
  border-top: 0;
}
</style>
